<template>
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
        <div class="mt-3 sm:mt-5" style="width: 370px;">
          <ErrorAlert v-if="$store.state.isError"/>


          <div class="bg-green-700 px-4 py-6 mb-10 sm:px-6">
            <div class="flex items-center justify-between">
              <h2 class="text-base font-semibold leading-6 text-white" id="slide-over-title" v-if="$parent.resolutionDate === ''">Update Defect</h2>
              <h2 class="text-base font-semibold leading-6 text-white" id="slide-over-title" v-if="$parent.resolutionDate !== ''">Defect Details</h2>
            </div>
          </div>

          <div class="mt-2 sm:col-span-2 sm:mt-0" v-if="$parent.resolutionDate !== ''">
            <h3 class="block text-base font-semibold leading-6 text-gray-900">Resolution Date: {{ $parent.resolutionDate }}</h3>
          </div>

          <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"  v-if="$parent.document_file !== null">
            <label for="resolution_description" class="block text-base font-semibold leading-6 text-gray-900">Defect Image</label>
            <div class="mt-2 sm:col-span-2 sm:mt-0">
              <img class="mb-5 mt-5 max-h-50 max-w-70 h-50" :src="$parent.document_file" />
            </div>
          </div>

          <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6" v-if="$parent.document_file == null">
            <label for="resolution_description" class="block text-base font-semibold leading-6 text-gray-900">Defect Image</label>
            <div class="mt-2 sm:col-span-2 sm:mt-0">
              <div class="flex w-16 flex-shrink-0 items-center justify-center text-sm font-medium">
                <label for="upload-button">
                  <input id="document_file" name="document_file" accept="image/*" capture="environment"  type="file" hidden @change="renderImage('document_file_img', 'document_file')">
                  <button
                      type="button"
                      class="bg-white-600 p-0 text-gray-800 hover:bg-white-500 border-0"
                      @click="chooseFile('document_file')"
                  >
                          <span class="fa-stack fa-2x mt-3 mb-2 item-center">
                            <img id="document_file_img" class="max-h-50 max-w-60 h-50 object-center invisible h-0" src="#" v-if="isDocumentFileSelected" height="50" width="60"/>
                            <i class="fa-solid fa-camera" v-if="!isDocumentFileSelected"></i>
                          </span>
                  </button>
                </label>
              </div>
            </div>
          </div>

          <div class="space-y-8 pb-6 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">

            <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6 ">
              <label for="resolution_description" class="block text-base font-semibold leading-6 text-gray-900">Defect Description</label>
              <div class="mt-2 sm:col-span-2 sm:mt-0">
                <textarea
                    rows="4"
                    name="description"
                    id="description"
                    class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder="Defect description"
                    v-model="$parent.description"
                    required
                />
              </div>
            </div>

            <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6 ">
              <label for="resolution_description" class="block text-base font-semibold leading-6 text-gray-900">Defect Area</label>
              <small class="italic text-red-600 text-xs ">Tap the image to set defect area</small>
              <div class="mt-2 sm:col-span-2 sm:mt-0">
                <img :src="$parent.defectArea" @click="updateDefectArea($parent.dvir_defect_type_id, 1)"/>
              </div>
            </div>
            <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6 ">
              <label for="resolution_description" class="block text-base font-semibold leading-6 text-gray-900">Resolution Description</label>
              <div class="mt-2 sm:col-span-2 sm:mt-0">
                <textarea
                    rows="4"
                    name="resolution_description"
                    id="resolution_description"
                    class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder="Resolution description"
                    v-model="$parent.resolutionDescription"
                    required
                />
              </div>
            </div>

            <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"  v-if="$parent.resolutionDate !== ''">
              <label for="resolution_description" class="block text-base font-semibold leading-6 text-gray-900">Resolution Image</label>
              <div class="mt-2 sm:col-span-2 sm:mt-0">
                  <img class="mb-5 mt-5 max-h-50 max-w-70 h-50" :src="$parent.resolutionFile" />
              </div>
            </div>

            <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"  v-if="$parent.resolutionDate === ''">
              <label for="resolution_description" class="block text-base font-semibold leading-6 text-gray-900">Resolution Image</label>
              <div class="mt-2 sm:col-span-2 sm:mt-0">
                <div class="flex w-16 flex-shrink-0 items-center justify-center text-sm font-medium">
                  <label for="upload-button">
                    <input id="resolution_document_file" name="resolution_document_file" accept="image/*" capture="environment"  type="file" hidden @change="renderImage('resolution_document_file_img', 'resolution_document_file')">
                    <button
                        type="button"
                        class="bg-white-600 p-0 text-gray-800 hover:bg-white-500 border-0"
                        @click="chooseFile('resolution_document_file')"
                    >
                          <span class="fa-stack fa-2x mt-3 mb-2 item-center">
                            <img id="resolution_document_file_img" class="max-h-50 max-w-60 object-center invisible h-0" src="#" v-if="isImageSelected"  width="60" height="50"/>
                            <i class="fa-solid fa-camera" v-if="!isImageSelected"></i>
                          </span>
                    </button>
                  </label>
                </div>
              </div>
            </div>


          </div>
        </div>
          <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
            <div class="mt-5 sm:mt-6 grid grid-cols-3 gap-4" v-if="$parent.resolutionDate === ''">
              <div>
                <button
                    type="button"
                    class="inline-flex w-full justify-center rounded-md bg-red-700 px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-red-300 hover:bg-red-800"
                    @click="$parent.deleteDefect"
                >
                  Delete
                </button>
              </div>
              <div>
                <button
                    type="button"
                    class="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-gray-300 hover:bg-gray-50"
                    @click="hidePreview"
                >
                  Close
                </button>
              </div>
              <div>
                <button
                    type="button"
                    class="inline-flex w-full justify-center rounded-md bg-green-700 px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-green-300 hover:bg-green-800"
                    @click="$parent.saveResolution"
                >
                  Save
                </button>
              </div>
            </div>
            <div v-if="$parent.resolutionDate !== ''">
              <button
                  type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md bg-red-700 px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-red-300 hover:bg-red-700 sm:col-start-1 sm:mt-0"
                  @click="hidePreview"
              >
                Close
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <ImagePreview v-if="showPreview" :isCreate="true"/>
</template>
<script>
import heic2any from "heic2any";
import ErrorAlert from "@/components/Common/ErrorAlert.vue";
import ImagePreview from "@/components/Common/ImagePreview.vue";

export default {
  name: 'ResolutionForm',
  components: {ImagePreview, ErrorAlert},
  props: [
    'isCreate'
  ],
  data() {
    return {
      isDocumentFileSelected: false,
      isImageSelected: false,
      resolution_document_file: '',
      showPreview: false
    }
  },
  methods: {
    hidePreview() {
      this.$parent.showResolution = false
    },
    chooseFile(fileInput) {
      document.getElementById(fileInput).click()
    },
    renderImage(id, fileInput) {
      const [file] = document.getElementById(fileInput).files
      console.log(file)

      const t = this
      if (file) {
        if (fileInput === 'resolution_document_file') {
          this.isImageSelected = true
        }
        if (fileInput === 'document_file') {
          this.isDocumentFileSelected = true
        }

        setTimeout(async function () {
          let convertedBlob = file;
          console.log(file.type)
          if (file.type === 'image/heif' || file.type === 'image/heic') {
            convertedBlob = await heic2any({ blob: file, toType: 'image/jpeg' });
          }

          let selectedImage = document.getElementById(id)
          selectedImage.src = URL.createObjectURL(convertedBlob)

          selectedImage.classList.remove('invisible')
          selectedImage.classList.remove('h-0')
          selectedImage.classList.add('resolutionImage')

          const reader = new FileReader()
          reader.readAsDataURL(convertedBlob);
          reader.onload = function(event) {
            const base64String = event.target.result.split(',')[1]; // Extract the Base64 part
            //localStorage.setItem('dvirImage_'+ fileInput, base64String);
            t.saveImageToLocal(fileInput, base64String)
            if (fileInput === 'document_file') {
              t.$parent.document_file = 'data:image/png;base64,' + base64String
            }
            if (fileInput === 'resolution_document_file') {
              t.$parent.resolutionFile = base64String
            }

          };
          // reader.readAsDataURL(file)
        }, 1000)
      }
    },
    saveImageToLocal(type, stringFile) {
      this.indexedDB = window.indexedDB
      if (!this.indexedDB) {
        console.log("IndexedDB could not be found in this browser.");
      }
      const request = indexedDB.open("ResolutionImage", 1);

      request.onerror = function (event) {
        console.error("An error occurred with IndexedDB");
        console.error(event);
      };

      request.onupgradeneeded = function () {
        const db = request.result;
        db.createObjectStore("images", { keyPath: "type" });
      };

      request.onsuccess = function () {
        console.log("Database opened successfully");
        const db = request.result;
        if (db.objectStoreNames.length === 0) {
          console.log('The database has no object stores.');
          db.close()
        } else {
          const transaction = db.transaction("images", "readwrite");
          const store = transaction.objectStore("images");
          store.put({ type: type, file: stringFile });
          transaction.oncomplete = function () {
            db.close()
          }
        }
      }
    },
    renderedUpdatedDefectArea(base64Image) {
      this.$parent.defectArea = base64Image;
    },
    updateDefectArea(typeId, categoryId) {
      if (this.$parent.isNewDvir) {
        this.showPreview = true
        this.selectedDefectType = typeId
        this.selectedDefectCategory = categoryId
      }
    },
    getImagesFromLocal(id)
    {
      const t = this
      this.indexedDB = window.indexedDB
      if (!this.indexedDB) {
        console.log("IndexedDB could not be found in this browser.")
      }

      const request = indexedDB.open("ResolutionImage", 1)

      request.onerror = function (event) {
        console.error("An error occurred with IndexedDB")
        console.error(event)
      };

      request.onsuccess = function () {
        const db = request.result
        if (db.objectStoreNames.length === 0) {
          console.log('The database has no object stores.');
          db.close()
        } else {
          console.log('DB: ' + JSON.stringify(db));
          const transaction = db.transaction(["images"], "readwrite")
          const store = transaction.objectStore("images")
          const idQuery = store.get(id)

          transaction.onerror = function(event) {
            console.log('Transaction error:', event.target.error);
          };

          idQuery.onsuccess = function () {
            if (id === 'resolution_document_file') {
              if (typeof idQuery.result !== 'undefined') {
                t.$parent.resolutionFile = idQuery.result.file
                return;
              }
            }
          }
        }
      }
    },
  },
  mounted() {
    //
  }
}
</script>
<style>
#document_file_img, #resolution_document_file_img {
  height: 50px !important
}
</style>